import React from 'react';
import { RenderSelectedFunction } from '@workday/canvas-kit-preview-react/select';
import colors from '@workday/canvas-colors-web';
import { SystemIcon } from '@workday/canvas-kit-react/icon';
import { globeIcon } from '@workday/canvas-system-icons-web';

export const RenderSelected: RenderSelectedFunction = option => {
    const iconColor = colors.blackPepper100;
    return (
        <div style={{ alignItems: 'center', display: 'flex' }}>
            <SystemIcon icon={globeIcon} color={iconColor} colorHover={iconColor} />
            <div style={{ marginLeft: 5 }}>{option.label}</div>
        </div>
    );
};
